import { CriteriaBase } from '@/shared/models/CriteriaBase.model';
import { TypeFacture } from '@/shared/enums/TypeFacture.enum';
import { EtatFacture } from '@/shared/enums/EtatFacture.enum';
import { DateHelper } from '@/shared/helpers/DateHelper';
import { StatutFiltreCertification } from '@/shared/models/StatutFiltreCertification';
import { EStatutPDP } from '@/shared/enums/EStatutPdp.enum';

/**
 * Liste des filtres possible pour récupérer la liste des factures.
 */
export class FactureCriteria extends CriteriaBase {
    /**
     * L'ensemble des contrats d'achat (installations) liés aux factures.
     */
    public ContratAchatGroupeIds: number[];
    /**
     * Types d'erreurs voulu.
     */
    public typeErreurCodes: string[];

    /**
     * Début de la période de filtrage.
     */
    public debutPeriode?: string;

    /**
     * Etat de la facture.
     */
    public etatFacture?: EtatFacture;

    /**
     * Fin de la période de filtrage.
     */
    public finPeriode?: string;

    /**
     * Numéro ou ID de la facture.
     */
    public numeroOuId?: string;

    /**
     * Type de la facture.
     */
    public typeFacture?: TypeFacture;

        /**
         * Le statut de la recherche par certification
         */
    public StatutFiltreCertification: StatutFiltreCertification = StatutFiltreCertification.Tous;

    /**
     * Le statut de la recherche par Statut Pdp.
     */
    public StatutFiltrePDP: EStatutPDP;

    /**
     * Initialise les valeurs par défaut du filtre de factures.
     */
    constructor() {
        super();
        this.ContratAchatGroupeIds = [];
        this.etatFacture = undefined;
        this.numeroOuId = undefined;
        this.typeFacture = undefined;

        // On initialise les dates pour filtrer les factures sur la période du mois courant et des trois mois précédents.
        const today = new Date();
        const debutPeriode = new Date(today.getFullYear(), today.getMonth() - 3);
        // Pour récupérer le dernier jour d'un mois, on initialise une date au mois voulu + 1 et le jour à 0.
        // Exemple : new Date(2020, 2, 0) => 2020-02-29. 2 correspond au mois de Mars.
        const finPeriode = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        this.finPeriode = DateHelper.creerDate(today.getFullYear(), today.getMonth() + 1, finPeriode.getDate());
        this.debutPeriode = DateHelper.creerDate(debutPeriode.getFullYear(), debutPeriode.getMonth() + 1, 1);
    }
}
